export interface CallStats {
  totalToday: number;
  connected: number;
  missed: number;
  avgDuration: string;
  totalAll?: number;
}

interface Props {
  stats?: CallStats;
  loading?: boolean;
}

export default function CallsStatsBar({ stats, loading = false }: Props) {
  const totalToday = stats ? stats.totalToday : 0;
  const connected = stats ? stats.connected : 0;
  const missed = stats ? stats.missed : 0;
  const avgDuration = stats ? stats.avgDuration : "0m";

  const items = [
    {
      label: "Total Today",
      value: loading ? "..." : String(totalToday),
      icon: "ri-phone-fill",
      color: "text-blue-600",
      iconBg: "bg-blue-50",
    },
    {
      label: "Connected",
      value: loading ? "..." : String(connected),
      icon: "ri-check-double-line",
      color: "text-emerald-600",
      iconBg: "bg-emerald-50",
    },
    {
      label: "Missed",
      value: loading ? "..." : String(missed),
      icon: "ri-close-circle-line",
      color: "text-red-600",
      iconBg: "bg-red-50",
    },
    {
      label: "Avg Duration",
      value: loading ? "..." : avgDuration,
      icon: "ri-timer-line",
      color: "text-amber-600",
      iconBg: "bg-amber-50",
    },
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {items.map((stat) => (
        <div
          key={stat.label}
          className="bg-white rounded-xl border border-gray-200 p-4 flex items-center gap-3.5 shadow-xs transition-shadow hover:shadow-sm"
        >
          <div className={`w-10 h-10 rounded-lg ${stat.iconBg} flex items-center justify-center flex-shrink-0`}>
            <i className={`${stat.icon} ${stat.color} text-lg`} />
          </div>
          <div>
            <p className="text-xs text-gray-500 uppercase tracking-wider font-semibold">{stat.label}</p>
            <p className="text-xl font-bold text-gray-900 mt-0.5">{stat.value}</p>
          </div>
        </div>
      ))}
    </div>
  );
}